/**
 * Component registry for portfolio panel components.
 *
 * Each entry maps a component name (used in markdown) to a factory function.
 * Factory contract: (props: object, index: number) => HTMLElement
 *
 * Usage in markdown:
 *   [component:image-compare before=/path/a.png after=/path/b.png]
 *
 * To add a new component:
 *   1. Create src/components/my-component.js exporting createMyComponent
 *   2. Import it here and add to the registry
 *   3. Safelist any new CSS class prefixes in vite.config.js
 */

import { createImageCompare } from './image-compare.js';
import { createLangflowCollage } from './langflow-collage.js';
import { createOpenragChat } from './openrag-chat.js';
import { createSystemsDialog } from './systems-dialog.js';
import { createThemeSandbox } from './theme-sandbox.js';

export const componentRegistry = {
  'image-compare': createImageCompare,
  'langflow-collage': createLangflowCollage,
  'openrag-chat': createOpenragChat,
  'systems-dialog': createSystemsDialog,
  'theme-sandbox': createThemeSandbox,
};
